import React from 'react';
import { FormattedMessage } from '@atlassian/jira-intl';
import { Link } from '@atlassian/jira-router';
import messages from './messages';

export const SignInRedirect = () => (
	<FormattedMessage
		{...messages.signIn}
		values={{
			// @ts-expect-error - Type '(msg: string) => JSX.Element' is not assignable to type 'ReactNode'.
			link: (msg: string) => (
				<Link to={`/login.jsp?os_destination=${window.location.href}`}>{msg}</Link>
			),
		}}
	/>
);
